declare global {
  interface Window {
    _env: {
      [key: string]: string;
    };
  }
}

const getSetting = (key: string): string | false => {
  if (window._env && key in window._env) {
    return window._env[key];
  }
  if (key in edmSettings) {
    return edmSettings[key];
  }

  return false;
};

export const apiHost = getSetting("apiHost") || "";
export const apiPath = getSetting("apiPath") || "";
export const apiEndpoint = `${apiHost}${apiPath}`;
export const apiOauthClientId = getSetting("oauth2ClientId") || "";

export const pageTitle = getSetting("pageTitle") || "Education Manager";
export const sentryDsn = getSetting("sentryDsn") || "";
export const sentryEnvironment = getSetting("sentryEnv") || "";
export const deployedVersion = getSetting("deployVersion") || "";
